import { render, staticRenderFns } from "./AddCompanyTagsModal.vue?vue&type=template&id=0d04ac3e&"
import script from "./AddCompanyTagsModal.vue?vue&type=script&lang=js&"
export * from "./AddCompanyTagsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports